import React from "react";
import {
  Box,
  Container,
  AppBar,
  Toolbar,
  Typography,
  Link,
} from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import theme from "../theme/theme";
import CookieConsentBanner from "../components/cookie/CookieConsent";

interface LegalLayoutProps {
  children: React.ReactNode;
}

const LegalLayout: React.FC<LegalLayoutProps> = ({ children }) => {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
      <AppBar
        position="static"
        sx={{ backgroundColor: theme.palette.primary.main }}
      >
        <Toolbar>
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            BeApolo
          </Typography>
          <Link
            component={RouterLink}
            to="/login"
            color="inherit"
            sx={{ ml: 2 }}
          >
            Login
          </Link>
        </Toolbar>
      </AppBar>

      <Container component="main" sx={{ mt: 4, mb: 4, flexGrow: 1 }}>
        {children}
      </Container>

      <CookieConsentBanner />

      <Box
        component="footer"
        sx={{
          py: 3,
          px: 2,
          mt: "auto",
          backgroundColor: theme.palette.neutral["100"],
        }}
      >
        <Container maxWidth="sm">
          <Typography variant="body2" color="text.secondary" align="center">
            © {new Date().getFullYear()} BeApolo
          </Typography>
        </Container>
      </Box>
    </Box>
  );
};

export default LegalLayout;
